// extracted by mini-css-extract-plugin
export var numberInputContainer = "_76-0";
export var startPickingButton = "_76-1";